import { useEffect, useState } from 'react';
import {
	createSearchParams,
	useNavigate,
	useSearchParams,
} from 'react-router-dom';

import { endpoints } from '@/API/endpoints';
import { useApi } from '@/hooks/useApi/useApi';
import { ApiDataType } from '@/types';

import classes from './Projects.module.scss';
import ProjectsHeader from './projects-header/ProjectsHeader';
import ProjectsList from './projects-list/ProjectsList';

const Projects = () => {
	const [isSingleColumn, setIsSingleColumn] = useState<boolean>(false);
	const { apiGet } = useApi();
	const [projects, setProjects] = useState<ApiDataType | null>(null);
	const [searchParams] = useSearchParams();
	const navigate = useNavigate();

	const handlerPreview = () => {
		setIsSingleColumn(!isSingleColumn);
	};

	const getProjects = async (params?: object | string) => {
		const res = await apiGet(endpoints.projects, params);
		setProjects(res);
		if (res.data.data.length <= 1) setIsSingleColumn(true);
	};

	const handleRouterParams = (
		searchQuery?: string | null,
		ordering?: string[] | null
	) => {
		const params = Object.assign(
			{},
			searchQuery && { search: searchQuery },
			// eslint-disable-next-line unicorn/explicit-length-check
			ordering && ordering.length && { ordering: ordering.join(',') }
		);
		if (params) {
			navigate({
				pathname: '/projects',
				search: createSearchParams(params).toString(),
			});
		}
	};

	const fetchProducts = (
		searchQuery: string | null,
		ordering: string | null
	) => {
		const params = Object.assign(
			{},
			searchQuery && { search: searchQuery },
			ordering && ordering.length > 0 && { ordering: ordering }
		);
		getProjects(params);
	};

	useEffect(() => {
		const search = searchParams.get('search');
		const ordering = searchParams.get('ordering');
		fetchProducts(search, ordering);
	}, [searchParams]);

	return (
		<div className={classes.container}>
			<ProjectsHeader
				handleRouterParams={handleRouterParams}
				isSingleColumn={isSingleColumn}
				handlerPreview={handlerPreview}
			/>
			<ProjectsList
				projects={projects}
				isSingleColumn={isSingleColumn}
				fetchProducts={fetchProducts}
			/>
		</div>
	);
};

export default Projects;
